<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" [iconClass]="'fas fa-briefcase'"></particle-breadcrumbs>
    </div>
  </div>

  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="createMemo()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Create Memo
          </button>

          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
    <!--    <div class="group-buttons">-->
    <!--      <button  mat-button class="grid-button"-->
    <!--               particleAnalytics-->
    <!--               analyticsCategory="projects-content"-->
    <!--               analyticsAction="relevant links"-->
    <!--               (click)="navigateToItrce()"><span>Open Legacy ITRCE</span> <i class="fal fa-sign-in m-l-5"></i>-->
    <!--      </button>-->
    <!--    </div>-->
  </div>

  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->

      <div *ngIf="memoCount==0">
        <particle-fuse-splash-screen type="beps-impact-reporter"
                                     (createMemo)="createMemo()"></particle-fuse-splash-screen>
      </div>

      <div class="content-card mat-white-bg">

        <div class="content pos-relative m-lr-30 m-b-30 m-t-20 flex flex-col">
          <div class="keno-grid-container" *ngIf="isGridReady">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)">
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>


<!--------------
PDF STYLING
----------------- >


<!--<div class="for-pdf">
  <div class="memo-ontainer">
    <h1 class="p-lr-10">Memorandum to File</h1>
    <h2 class="p-lr-10">Interest and Penalty Calculation</h2>
    <table class="p-lr-10">
      <tr>
        <th>To:</th>
        <th>From:</th>
        <th>Date:</th>
        <th>Reviewer:</th>

      </tr>
      <tr>
        <td>Oliver Long</td>
        <td>Don Chung</td>
        <td>07/08/2020</td>

        <td>Gratian Joseph</td>
      </tr>
    </table>
    <section>
      <h6 class="p-lr-10">Facts</h6>
      <div class="content">
        An entity in United States may be assessed interest and penalty from 40178 arising from
        12/31/2009 on the disputed amount of 1,000.00
      </div>
    </section>

    <section>
      <h6 class="p-lr-10">Issue</h6>
      <div class="content">
        What is interest and penalty amount?
      </div>
    </section>

    <section>
      <h6>Conclusion</h6>
      <div class="content">
        The amount is 0.00 as follows:
      </div>
      <div class="content">
        Interest: <span>0.00</span>
      </div>
      <div class="content">
        Penalty: <span>0.00</span>
      </div>
    </section>

    <section>
      <h6 class="p-lr-10">Analysis</h6>
      <div class="content">
       <strong> Interest Section</strong>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Late Interest <span>0.00%</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Index <span>0.00%</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Compounding <span>0</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Due From
        <span>12/31/2019</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        End Accrual Period
        <span> 07/08/2020</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Total        <span> 0.00</span>
      </div>
    </section>



    <section class="m-t-25">
      <div class="content">
        <strong>Monetary Penalty
        </strong>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Monetary Penalty Amount1 <span>0.00%</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Monetary Penalty Amount2 <span>0.00%</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Monetary Penalty Percentage <span>0</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          <div>
            Monetary Penalty Percentage Cap
          </div>
          <label class="f-s-12 m-t-5">
            The cap on the monetary penalty as a percentage of the disputed amount. So, if you have an annual
            monetary penalty of 10% for 3 years than with a 20% cap. you will only have to pay 20%

          </label>

        </div>
        <span>0.00%</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          <div>
            Monetary Penalty Rest
          </div>
          <label class="f-s-12 m-t-5">
            Any penalty in addition to the other monetary penalty features. The field also sometimes contains
            explanations for the other monetary fields

          </label>

        </div>
        <span>0.00%</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Total        <span> 0.00</span>
      </div>
    </section>
    <section class="m-t-25">
      <div class="content">
        <strong>Tax Deductibility</strong>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Interest Deductible
        <span>No</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Principal Deductible
        <span>No</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          Monetary Penalty Percentage
        </div> <span>0</span>
      </div>
    </section>


    <section class="m-t-25">
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          Tax Deductibility
        </div>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
       <div class="m-r-80">
         Interest Deductible
       </div>        <span> No</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          Principal Deductible
        </div>        <span> No</span>
      </div>

      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          Penalty Deductible
        </div>        <span> No</span>
      </div>
    </section>
    <section class="m-t-25">
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Statue of Limitations
      </div>

      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
       <div  class="m-r-80">
         Statue of Limitations
       </div> <span>0</span>
      </div>

      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="m-r-80">
          Start Statue of Limitations
        </div>        <span>12/31/2019</span>
      </div>
    </section>
    <section class="m-t-25">
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Results
      </div>

      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Interest Deductible        <span> No</span>
      </div>
      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Interest Deductible        <label> Interest</label> <label> Monetary Damages</label>
      </div>

      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Pre-Tax        <span> 0.00</span> <span> 0.00</span>
      </div>

      <div class="content" fxLayout="row" fxLayoutAlign="space-between center">
        Pre-Tax        <span> 0.00</span> <span> 0.00</span>
      </div>
    </section>

  </div>
</div>-->

